import React from "react";
import PropTypes from "prop-types";
import { FaChevronUp } from "react-icons/fa/";
import moment from "moment";
import AuthorFooter from "./AuthorFooter";
import RecommendedArticleFooter from "./RecommendedArticleFooter";

class PostFooter extends React.Component {
  state = {
    showSocial: false
  };

  getFooterClasses = () => {
    const classes = this.props.fixed ? "fixedFooter" : "";
    return classes;
  };

  render() {
    const {
      theme,
      prev,
      next,
      authorId,
      postDate,
      postTitle,
      postExcerpt,
      postUrl,
      postCover
    } = this.props;

    return (
      <React.Fragment>
        <footer className={`postinfo ${this.getFooterClasses()}`}>
          <AuthorFooter
            theme={theme}
            postTitle={postTitle}
            postExcerpt={postExcerpt}
            postUrl={postUrl}
            postDate={postDate}
            showRelatedPosts={this.props.showRelatedPosts}
            authorId={authorId}
            postCover={postCover}
          />
          <RecommendedArticleFooter
            theme={theme}
            next={next}
            prev={prev}
            showRelatedPosts={this.props.showRelatedPosts}
          />
        </footer>

        {/* --- STYLES --- */}
        {/*language=SCSS*/}
        <style jsx>{`
          .postinfo {
            transform: translateY(0%);
            bottom: 0;
            left: 0;
            width: 100%;
            background: #fff;
            height: 75px;
            border-top: 2px solid #f2f2f2;
            z-index: 1500;
            @include transition(left 500ms ease-in-out);
            @include transform(translateY(0%));

            &.slide {
              left: -400px;
            }

            &.fixedFooter {
              position: fixed;
            }

            @media (max-width: 750px) {
              display: none !important;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

PostFooter.propTypes = {
  theme: PropTypes.object.isRequired,
  postTitle: PropTypes.string.isRequired,
  postExcerpt: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
  postCover: PropTypes.object,
  prev: PropTypes.object,
  postDate: PropTypes.string,
  next: PropTypes.object,
  fixed: PropTypes.bool.isRequired,
  showRelatedPosts: PropTypes.bool.isRequired,
  authorId: PropTypes.string.isRequired
};

export default PostFooter;
